define([
    'underscore',
    './config/RouteConfig',

    './directives/MFPAddVehicle',
    './directives/MFPCreateContact',
    './directives/MFPDownloadDocument',
    './directives/MFPPersonificationContact',
    './directives/MFPShowVehicle',
    './directives/MFPShowCoverages',
    './directives/MFPCarData',
    './directives/MFPPromotionData',
    './directives/MFPProofOfInsurance',
    './directives/MFPQuotingPageCoverageView',
    './directives/MFPSelectLeasingDuration',
    './directives/MFPSelectDealer',
    './directives/MFPPartnerData',
    './directives/MFPLeasingInformation',
    './directives/MFPPartnerLink',
    './directives/MFPSubmitButton',

    './services/MFPService',
    './services/MFPCoverageService',
    './services/MFPPartnerService',
    './services/MFPPromotionService',
    './services/MFPValidationService',

    './constants/MFPDtoClasses',
    './constants/MFPFavouriteCountryCodesForNationality',
    './constants/MFPVehicleConstants',

    'edge/quoteandbind/common/app',
    'edge/policyjob/app',
    'edge/quoteandbind/baslercommon/app',

    'angularRouter',
    'angularBootstrap',
    'angular-animate',

], (
    _,
    RouteConfig, // NOSONAR
    AddVehicle,
    MFPCreateContact,
    DownloadDocument,
    PersonificationContact,
    ShowVehicle,
    ShowCoverages,
    CarData,
    MFPPromotionData,
    MFPProofOfInsurance,
    MFPQuotingPageCoverageView,
    MFPSelectLeasingDuration,
    MFPSelectDealer,
    MFPPartnerData,
    MFPLeasingInformation,
    MFPPartnerLink,
    MFPSubmitButton,
    MFPService,
    MFPCoverageService,
    MFPPartnerService,
    MFPPromotionService,
    MFPValidationService,
    MFPDtoClasses,
    MFPFavouriteCountryCodesForNationality,
    MFPVehicleConstants
) => {
    return angular.module('edge.quoteandbind.mfp.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'edge.quoteandbind.common.basler', 'ngAnimate', 'ngSanitize'])

        .config(['$stateProvider', 'state_plugin_config', ($stateProvider, RootStateConfig) => {
            const states = new RouteConfig(RootStateConfig);
            Object.keys(states).forEach(stateName => $stateProvider.state(stateName, states[stateName]));
        }])

        .filter('orderObjectBy', () => function (items, field, reverse) {
            const filtered = [];
            angular.forEach(items, (item) => {
                filtered.push(item);
            });
            filtered.sort((a, b) => {
                if (a[field] > b[field]) {
                    return 1;
                }
                if (a[field] < b[field]) {
                    return -1;
                }
                return 0;
            });
            if (reverse) {
                filtered.reverse();
            }
            return filtered;
        })

        .run(['ExpressionLanguageService', 'MFPValidationService', function (ExpressionLanguage, MFPValidationService) { // eslint-disable-line no-shadow
            ExpressionLanguage.getCompilationContext('pc').registerType('ch.baloise.gw.pc.edge.capabilities.quote.lob.mfp.draft.util.MFPVehicleUtil_Ext', {
                validateMatriculationNumber: MFPValidationService.validateMatriculationNumber,
                validateMatriculationNumbersUnique: MFPValidationService.validateMatriculationNumbersUnique,
                validatePaidTransportOfGoodsUse: MFPValidationService.validatePaidTransportOfGoodsUse,
                validateRegistrationDate: MFPValidationService.validateRegistrationDate,
                validateVehicleDrivers: MFPValidationService.validateVehicleDrivers,
            });
        }])

        .run(['ExpressionLanguageService', 'StateUtils', 'BaslerCompanySearchService', 'MFPValidationService', function (ExpressionLanguage, StateUtils, BaslerCompanySearchService, MFPValidationService) { // eslint-disable-line no-shadow
            ExpressionLanguage.getCompilationContext('pc').registerType('ch.baloise.gw.pc.edge.capabilities.quote.contact.BaslerContactUtil', {
                comparePeriodStartAndBirthDate: MFPValidationService.comparePeriodStartAndBirthDate,
                validateCompanyUID: BaslerCompanySearchService.validateCompanyUID,
            });
        }])

        .run(['ExpressionLanguageService', 'BaslerDateUtilService', 'BaslerCommonService', 'MFPValidationService', function (ExpressionLanguage, BaslerDateUtilService, BaslerService, MFPValidationService) { // eslint-disable-line no-shadow
            ExpressionLanguage.getCompilationContext('pc').registerType('ch.baloise.gw.pc.edge.capabilities.quote.draft.BaslerDraftSubmissionPlugin', {
                comparePeriodStartAndFirstRegistration: MFPValidationService.comparePeriodStartAndFirstRegistration,
                validatePeriodStartDateIsStillValid: BaslerService.isNotExpiredQuote,
                validatePeriodStartDateNotTooFarInTheFuture: BaslerService.validatePeriodStartDateNotTooFarInTheFuture,
            });
        }])

        .run(['$rootScope', '$state', function($rootScope, $state) {
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) =>{
                if (fromState.name === '' && ['mfpRiskRelevantData', 'mfpQuoteDetails', 'mfpPersonificationQualification', 'mfpSummary', 'mfpConfirmation', 'mfpContactUs'].includes(toState.name)) {
                    event.preventDefault();
                    $state.go('home');
                }
            });
        }])

        .directive('mfpAddVehicle', AddVehicle)
        .directive('mfpCreateContact', MFPCreateContact)
        .directive('mfpDownloadDocument', DownloadDocument)
        .directive('mfpPersonificationContact', PersonificationContact)
        .directive('mfpShowVehicle', ShowVehicle)
        .directive('mfpShowCoverages', ShowCoverages)
        .directive('mfpCarData', CarData)
        .directive('mfpPromotionData', MFPPromotionData)
        .directive('mfpProofOfInsurance', MFPProofOfInsurance)
        .directive('mfpQuotingPageCoverageView', MFPQuotingPageCoverageView)
        .directive('mfpSelectLeasingDuration', MFPSelectLeasingDuration)
        .directive('mfpSelectDealer', MFPSelectDealer)
        .directive('mfpPartnerData', MFPPartnerData)
        .directive('mfpLeasingInformation', MFPLeasingInformation)
        .directive('mfpPartnerLink', MFPPartnerLink)
        .directive('mfpSubmitButton', MFPSubmitButton)
        .factory('MFPService', MFPService)
        .factory('MFPCoverageService', MFPCoverageService)
        .factory('MFPPartnerService', MFPPartnerService)
        .factory('MFPPromotionService', MFPPromotionService)
        .factory('MFPValidationService', MFPValidationService)
        .constant('VinLookupEnabled', true)
        .constant('DTO_CLASSES', MFPDtoClasses)
        .constant('MFP_FAVOURITE_COUNTRY_CODES_FOR_NATIONALITY', MFPFavouriteCountryCodesForNationality)
        .constant('MFP_VEHICLE_CONSTANTS', MFPVehicleConstants)
        .constant('TCS_PRODUCT_CODE', 'TCSCombiMotorfahrzeug');
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/app.js